// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require("./../Sass/base.scss");

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require("babel-polyfill");
}

import * as helper from "./../../../../../VX/View/Assets/Js/helper";
import { initImprint } from "../../../Assets/JS/imprint_la";

helper.onDocumentLoaded(() => {
	initImprint(helper.$("#impressumlink"), helper.$("#datenschutzlink"));

	const wrapper: HTMLDivElement = helper.$("#wrapper");
	const steps = helper.$(".survey");
	let index = 0;
	const buttons: HTMLAnchorElement[] = Array.from(helper.$(".step-btn"));
	const firstButton = buttons.shift();
	const lastButton = buttons.pop();

	const url1 = helper.getData(wrapper, "url1");
	const url2 = helper.getData(wrapper, "url2");

	buttons.map((button) => {
		helper.addClickListener(button, () => {
			helper.hide(steps[index]);
			index++;
			helper.removeClass(steps[index], "d-none");
		});
	});

	const options = document.querySelectorAll<HTMLImageElement>(".option-item");

	firstButton.addEventListener("click", () => {
		// Check if any of the options is selected
		if (!Array.from(options).some((option) => helper.hasClass(option, "selected"))) {
			return;
		}

		helper.hide(steps[index]);
		index++;
		helper.removeClass(steps[index], "d-none");
	});

	options.forEach((option) => {
		helper.addClickListener(option, () => {
			options.forEach((o) => {
				helper.removeClass(o, "selected");
			});
			helper.addClass(option, "selected");
			const url = option.src;
			["image1", "image2", "image3"].forEach((id, index) => {
				document
					.getElementById(id)
					.setAttribute("src", url.replace(".jpg", `_0${index + 1}.jpg`).replace("300x300", "550x400"));
			});
		});
	});

	helper.addClickListener(lastButton, () => {
		window.open(url1);
		window.location.href = url2;
	});
});
